import React from 'react';
import PropTypes from 'prop-types';

import UserTile from './components/UserTile';

const propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      username: PropTypes.string,
    }),
  ).isRequired,
};

const UserSearchResultListing = ({ users = [] }) => {
  return (
    <div className="row">
      {users.map(user => (
        <div className="col-sm-6 col-12" key={user.id}>
          <UserTile user={user} />
        </div>
      ))}
    </div>
  );
};

UserSearchResultListing.propTypes = propTypes;

export default UserSearchResultListing;
